module.exports = __webpack_public_path__ + "static/img/136.0286026.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/136.png
// module id = pwq3
// module chunks = 0